import React, { useEffect, useState, useRef } from "react";
import {
  Col,
  Row,
  Select,
  Input,
  Button,
  DatePicker,
  Form,
  InputNumber,
  Popconfirm,
  Tooltip,
  Table,
  Card
} from "antd";
import { useTranslation } from "react-i18next";
import { noWhitespace } from "../../../../../utils/rules";
import { notify } from "../../../../../redux/actions";
import aictia from "../../../../../const/api";
import moment from "moment";
import { connect } from "react-redux";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { convertColumns } from "../../../../../utils/columnconverter";
import {
  EditFilled,
  DeleteFilled,
} from "@ant-design/icons";
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from "primereact/floatlabel";
// import ProjectTablee from "../project/table"
const { Option } = Select;

function StartUp(props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const mainUrl = "Startup";

  const [fieldOfUse, setFieldOfUse] = useState([]);
  const [typeOfStartup, setTypeOfStartup] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [categoriesType, setCategoriesType] = useState([]);
  const [cutValue, setCutValue] = useState();
  const [subDisable, setSubDisable] = useState(true);
  const [typeDisable, setTypeDisable] = useState(true);
  const [positions, setPositions] = useState([]);
  const [spin, setSpin] = useState(false);
  const [editing, setEditing] = useState(null);
  const [field, setField] = useState([]);
  const [startupCate, setStartupCate] = useState([]);
  const [techArray, setTechArray] = useState([0]);
  const editor = useRef();
  const nameInput = useRef();
  const [isInnovationCer, setIsInnovationCer] = useState(false);
  const [isPatent, setIsPatent] = useState(false);

  // props
  const { notify } = props;

  const getFieldOfUse = () => {
    aictia.get("UsageArea").then((res) => {
      setFieldOfUse(res.data);
    });
  };
  //
  const getTypeOfProject = () => {
    aictia.get("TypeOfStartup").then((res) => {
      setTypeOfStartup(res?.data);
    });
  };
  //cate
  const getCategories = () => {
    aictia.get("TechnologyFilter/TechnologyFields").then((res) => {
      setCategories(res.data.technologyCagegory);
    });
  };

  //subcate
  const getSubcategories = (value, index) => {
    let cate = subCategories;

    cate = cate.filter((elem) => elem.index !== index);

    const subCate = categories.find(
      (item) => item.id === value
    ).technologySubCagegory;
    setSubCategories([...cate, { index: index, array: subCate }]);

    setSubDisable(false);
    form.resetFields([["startupCategories", index, "technologySubcategoryId"]]);
    form.resetFields([["startupCategories", index, "technologyTypeId"]]);
  };

  //type
  const getCategoriesType = (value, index) => {
    let cateType = categoriesType;
    cateType = cateType.filter((item) => item.index !== index);
    const data = subCategories.find((item) => item.index === index).array;
    const type = data.find((item) => item.id === value).technologyType;

    setCategoriesType([...cateType, { index: index, array: type }]);

    setTypeDisable(false);
    form.resetFields([["startupCategories", index, "technologyTypeId"]]);
  };

  const setEditingObject = async (i) => {
    setEditing(i);

    await aictia.get(mainUrl + `/${i}`).then((res) => {
      setSubDisable(false);
      setTypeDisable(false);
      setField(res.data.startupUsageAreas);
      setStartupCate(res?.data.startupCategories);

      const techArray1 = [];
      let subCategoriesModify = [];
      let categoriesTypeModify = [];
      res.data.startupCategories.map((item, index) => {
        techArray1.push(index);

        //subCate
        const subCate = categories.find(
          (elem) => elem.id === item.technologyCategoryId
        ).technologySubCagegory;
        subCategoriesModify = [
          ...subCategoriesModify,
          { index: index, array: subCate },
        ];

        //type
        const data = subCategoriesModify.find(
          (elem) => elem.index === index
        ).array;
        const type = data.find(
          (elem) => elem.id === item.technologySubcategoryId
        ).technologyType;
        categoriesTypeModify = [
          ...categoriesTypeModify,
          { index: index, array: type },
        ];
      });
      setSubCategories(subCategoriesModify);
      setCategoriesType(categoriesTypeModify);
      setTechArray(techArray1);

      setTimeout(() => {
        form.setFieldsValue({
          ...res.data,
          startDate: moment(res.data.startDate),
          endDate: moment(res.data.endDate),

          usageAreaId: res.data.startupUsageAreas.map(
            (item) => item.usageAreaId
          ),
        });
      }, 1000);
    });
  };

  const getPositions = async () => {
    setSpin(true);
    await aictia.get(`${mainUrl}?companyid=${props.id}`).then((res) => {
      setSpin(false);
      setPositions(
        res.data.map((p, index) => {
          return {
            key: index + 1,
            ...p,
            index: index + 1,
          };
        })
      );
    });
  };

  const deletePosition = async (i) => {
    await aictia
      .delete(`${mainUrl}/${i}`)
      .then(() => {
        // description
        notify("silindi", true);
        getPositions();
      })
      .catch((err) => {
        //error
        notify(err.response, false);
      });
  };

  const cancelEditing = () => {
    setEditing(null);
    setTechArray([0]);
    setIsInnovationCer(false);
    setIsPatent(false);
    form.resetFields();
  };
  const save = async (values) => {
    const data = {
      ...values,
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
      reyestrOfCompanyId: props.id,
      certificate: isInnovationCer,
      patent: isPatent,
      startupUsageAreas: values?.usageAreaId ? values?.usageAreaId.map((item) => {
        return {
          usageAreaId: item,
        };
      }) : []
    };

    if (!editing) {
      await aictia
        .post(mainUrl, data)
        .then((res) => {
          notify("", true);
          getPositions();
          cancelEditing();
        })
        .catch((err) => {
          notify(err.response, false);
        });
    } else {
      //field

      const dataUsageAreaIds = data.startupUsageAreas.map(
        (item) => item.usageAreaId
      );
      const updateFieldsIds = field.map((elem) => elem.usageAreaId);
      const updatedField = field.map((item) => {
        const isActive = dataUsageAreaIds.includes(item.usageAreaId);
        return { ...item, isActive };
      });

      data.startupUsageAreas.map((elem) => {
        elem.isActive = true;
      });
      data.startupUsageAreas = data.startupUsageAreas.filter(
        (elem) => !updateFieldsIds.includes(elem.usageAreaId)
      );
      data.startupUsageAreas.push(...updatedField);

      //cate

      const modifyData = data.startupCategories.filter(
        (item) => item != undefined
      );
      const startupCategoryIds = modifyData.map((item) => item.id);

      const updatedInnovationCate = startupCate.map((item) => {
        const isActive = startupCategoryIds.includes(item.id);
        return { ...item, isActive };
      });

      modifyData.map((elem) => {
        elem.isActive = true;
      });
      modifyData.push(
        ...updatedInnovationCate.filter((elem) => elem.isActive === false)
      );
      data.startupCategories = modifyData;

      await aictia
        .put(`${mainUrl}/${editing}`, { ...data, id: editing })
        .then((res) => {
          notify("", true);
          getPositions();
          cancelEditing();
        })
        .catch((err) => {
          notify(err.response, false);
        });
    }
  };

  useEffect(() => {
    getFieldOfUse();
    getTypeOfProject();
    getCategories();
    getPositions();
  }, []);

  const cols = [
    { key: "index", value: "#", con: true },
    { key: "startDate", value: "Başlama tarixi ", con: true },
    { key: "typeOfStartup", value: "Startapın növü", con: true },
    { key: "budget", value: "Büdcə", con: true },
    { key: "id", value: "", con: false },
  ];
  const columns = [
    {
      title: "#",
      key: "1",
      dataIndex: "index",
      width: 80,
    },
    {
      title: "Startapın adı",
      dataIndex: "startupName",
      key: "11",

    },
    {
      title: "Başlama tarixi",
      dataIndex: "startDate",
      key: "2",
      render: (i) => {
        return moment(i).format("YYYY-MM-DD");
      },
    },

    {
      title: "Startapın növü",
      dataIndex: "typeOfStartup",
      key: "3",
      render: (i) => {
        return <p>{i.name}</p>;
      },
    },
    {
      title: "Büdcə",
      dataIndex: "budget",
      key: "4",
      render: (i) => {
        return <p>{i} azn</p>;
      },
    },
    {
      title: "Tamamlanma",
      dataIndex: "completenessOfStartup",
      key: "5",
      render: (i) => {
        return <p>{i} %</p>;
      },
    },
    {
      title: "",
      key: "6",
      dataIndex: "id",
      width: 30,
      render: (i) => {
        return (
          <div className="flex flex-end">
            <Popconfirm
              placement="topRight"
              title={t("areYouSure")}
              onConfirm={() => deletePosition(i)}
              okText={t("yes")}
              cancelText={t("no")}
            >
              <Tooltip className="ml-5" title={t("delete")}>
                <Button className="border-none" type="text" shape="circle">
                  <DeleteFilled />
                </Button>
              </Tooltip>
            </Popconfirm>
            <Tooltip className="ml-5" title={t("edit")} placement="topRight">
              <Button
                className="border-none"
                type="text"
                shape="circle"
                onClick={() => setEditingObject(i)}
              >
                <EditFilled />
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const handleDeleteRow = (element) => {
    if (techArray.length > 1) {
      setTechArray(techArray.filter((elem) => elem !== element));
      form.resetFields([
        ["startupCategories", element, "technologyCategoryId"],
      ]);
      form.resetFields([
        [["startupCategories", element, "technologySubcategoryId"]],
      ]);
      form.resetFields([[["startupCategories", element, "technologyTypeId"]]]);
    }
  };
  return (
    <div>
      <Form layout="vertical" onFinish={save} form={form}>
        <div className={`commontask taskkk detail mb-30`}>
          <Card>

            <Row gutter={[16, 32]}>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="startupName"
                    validateTrigger="onChange"
                    rules={[noWhitespace(t("inputError"))]}

                  >
                    <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="startupName" />
                  </Form.Item>
                  <label htmlFor="startupName">{t("Startapın adı  ")} <span style={{ color: 'red' }}>*</span></label>


                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="startDate"
                    validateTrigger="onChange"
                  >
                    <DatePicker style={{borderRadius: "12px"}} placeholder={t("Tarixi seçin")} className="w-100" />

                  </Form.Item>
                  <label htmlFor="startDate">{t("Startapın başlama tarixi")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="typeOfStartupId"
                    validateTrigger="onChange"
                    rules={[noWhitespace(t("inputError"))]}

                  >
                    <Select className="custom-select">
                      {typeOfStartup.map((p, index) => {
                        return (
                          <Option key={index} value={p.id}>
                            {p.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <label htmlFor="typeOfStartupId">{t("Startapın növü")}<span style={{ color: 'red' }}>*</span></label>
                </FloatLabel>
              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="usageAreaId"
                    validateTrigger="onChange"
                  //   rules={[whiteSpace(t("inputError"))]}
                  >
                    <Select className="custom-select"
                      mode="multiple"
                      maxTagCount={1}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {fieldOfUse.map((p, index) => {
                        return (
                          <Option key={index} value={p.id}>
                            {p.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <label htmlFor="usageAreaId">{t("İstifadə sahəsi")}</label>
                </FloatLabel>
              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <div className="form-lang">
                    <Form.Item
                      name="budget"
                      validateTrigger="onChange"
                    >
                      <InputNumber style={{borderRadius: "12px"}} defaultValue={0} />
                    </Form.Item>
                    <div className="input-lang">azn</div>
                  </div>
                  <label htmlFor="budget">{t("Büdcə")}</label>
                </FloatLabel>
              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <div className="form-lang">
                    <Form.Item
                      name="completenessOfStartup"
                      validateTrigger="onChange"
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value >= 0 && value <= 100) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error(t("Dəyər 0 ilə 100 arasında olmalıdır!")));
                          },
                        },
                      ]}
                    >
                      <InputNumber style={{borderRadius: "12px"}} max={100} min={0} />
                    </Form.Item>
                    <div className="input-lang">%</div>
                  </div>
                  <label htmlFor="completenessOfStartup">{t("Startapın tamamlığı")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>

                  <Form.Item
                    name="webPageUrl"
                    validateTrigger="onChange"
                  >
                    <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="webPageUrl" />
                  </Form.Item>
                  <label htmlFor="webPageUrl">{t("Web səhifə")}</label>
                </FloatLabel>
              </Col>
              {techArray.map((elem, index) => (
                <Col className="flex  flex-align-center " key={index}>
                  <div style={{ display: "none" }}>
                    <FloatLabel>
                      <Form.Item
                        name={["startupCategories", elem, "id"]}
                        validateTrigger="onChange"
                      >
                        <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="id" />
                      </Form.Item>
                      <label htmlFor="id">{t("Texnologiyanın kateqoriyası")}</label>
                    </FloatLabel>

                  </div>
                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>

                      <Form.Item
                        name={["startupCategories", elem, "technologyCategoryId"]}
                        validateTrigger="onChange"
                      >
                        <Select className="custom-select" onChange={(value) => getSubcategories(value, elem)}>
                          {categories.map((p, index) => {
                            return (
                              <Option key={index} value={p.id}>
                                {p.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologyCategoryId">{t("Texnologiyanın kateqoriyası")}</label>
                    </FloatLabel>
                  </Col>

                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>
                      <Form.Item
                        name={[
                          "startupCategories",
                          elem,
                          "technologySubcategoryId",
                        ]}
                        validateTrigger="onChange"
                      >
                        <Select className="custom-select"
                          onChange={(value) => getCategoriesType(value, elem)}
                          disabled={subDisable}
                        >
                          {subCategories?.map((item) => {
                            if (item.index === elem) {
                              return item.array.map((p, index) => {
                                return (
                                  <Option key={index} value={p.id}>
                                    {p.name}
                                  </Option>
                                );
                              });
                            }
                          })}
                        </Select>

                      </Form.Item>
                      <label htmlFor="technologySubcategoryId">{t("Alt kateqoriyası")}</label>
                    </FloatLabel>
                  </Col>
                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>
                      <Form.Item
                        name={["startupCategories", elem, "technologyTypeId"]}
                        validateTrigger="onChange"
                      >
                        <Select className="custom-select" disabled={typeDisable}>
                          {categoriesType.map((item) => {
                            if (item.index === elem) {
                              return item.array.map((p, index) => {
                                return (
                                  <Option key={index} value={p.id}>
                                    {p.name}
                                  </Option>
                                );
                              });
                            }
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologyTypeId">{t("Növü")}</label>
                    </FloatLabel>
                  </Col>

                  <div>
                    <Button
                      onClick={() => setTechArray([...techArray, techArray[techArray.length - 1] + 1])}
                      className={"ml-15"}
                      type={"primary"}
                      shape={"circle"}
                      icon={<PlusOutlined />}
                    />
                    <Button
                      onClick={() => {
                        handleDeleteRow(elem);
                      }}
                      className={"ml-15"}
                      type={"primary"}
                      shape={"circle"}
                      icon={<MinusOutlined />}
                    />
                  </div>
                </Col>
              ))}
            </Row>
            <div className="flex flex-end mb-20">
              <Button style={{borderRadius: "12px"}} onClick={cancelEditing}>{t("cancel")}</Button>

              <Button style={{borderRadius: "12px"}} type="primary" className="ml-10" htmlType="submit">
                {t("save")}
              </Button>
            </div>
          </Card>
        </div>
      </Form>
    </div>
  );
}

export default connect(null, { notify })(StartUp);

